var _defs, _g, _g2, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _circle4, _path7, _path8, _path9, _path10, _circle5, _circle6, _circle7, _path11, _path12, _path13, _g3, _circle8, _circle9, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #878585;\n      }\n\n      .st1 {\n        fill: #a10a46;\n      }\n\n      .st2 {\n        fill: #126398;\n      }\n\n      .st3 {\n        fill: #9ca507;\n      }\n\n      .st4 {\n        fill: #fff;\n        stroke: #bfcc01;\n        stroke-miterlimit: 10;\n        stroke-width: 8px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130,64.4c0,.3-.1.5-.2.7-.1.2-.3.4-.5.5s-.4.3-.8.3h-2.7v2.2h-.8v-5.6h3.7c.3,0,.5.2.7.3s.4.3.5.5c0,.4.1.7.1.9v.2ZM129.2,64.5c0-.4-.1-.6-.4-.8-.3-.2-.6-.3-1.1-.3h-1.8v2.2h1.7c1.1,0,1.6-.4,1.6-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,68.4l-.6-1.4h-2.9l-.6,1.4h-.8l2.4-5.6h.9l2.4,5.6h-.8ZM133.9,64.5s-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.2c0,0,0,0-.1.2-.1.1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3l-.8,1.8h2.4s-.8-1.8-.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143,65.5c0,.5-.1.9-.3,1.3-.2.4-.4.7-.7.9-.3.2-.6.4-1.1.5-.4,0-.8.2-1.3.2h-1.7v-5.6h1.8c.5,0,.9,0,1.3.2.4,0,.7.3,1,.5s.5.5.7.9c.3.2.3.6.3,1.1ZM142.3,65.6c0-.7-.2-1.3-.6-1.7-.4-.4-1-.6-1.8-.6h-1v4.5h2c.3,0,.6-.2.8-.4.2-.2.4-.4.5-.7,0-.3.1-.7.1-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.9,68.4v-5.6h4.2v.6h-3.4v1.8h2v.6h-2v2.1h3.6v.6h-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151,68.4v-5.6h.8v5h3.4v.6h-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.9,68.4v-5.6h.8v5.6h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.1,68.4l-3.1-3.8v-.6c0-.2,0,0,0,0v4.6h-.8v-5.6h.8l3,3.9v.6c0,.2,0,0,0,0v-4.6h.8v5.6h-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175,65.5c0,.5,0,.9-.3,1.3s-.4.7-.7.9c-.3.2-.6.4-1.1.5s-.8.2-1.3.2h-1.7v-5.6h1.9c.5,0,.9,0,1.3.2.4,0,.7.3,1,.5s.5.5.7.9c0,.2.2.6.2,1.1ZM174.2,65.6c0-.7-.2-1.3-.6-1.7-.4-.4-1-.6-1.8-.6h-1v4.5h2c.3,0,.6-.2.8-.4.2-.2.4-.4.5-.7v-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.3,65.6c0,.4,0,.8-.2,1.2,0,.4-.3.7-.6.9-.3.3-.6.5-.9.6-.4,0-.8.2-1.2.2s-.8,0-1.2-.2-.7-.3-.9-.6c-.3-.3-.4-.6-.6-.9,0-.4-.2-.7-.2-1.2s0-.8.2-1.2c0-.4.3-.7.6-.9.3-.3.6-.5.9-.6.4,0,.8-.2,1.2-.2s.8,0,1.2.2c.4,0,.7.3.9.6.3.3.4.6.6.9,0,.3.2.7.2,1.2ZM181.5,65.6c0-.4,0-.7-.2-1s-.3-.5-.4-.7c-.2-.2-.4-.4-.7-.5s-.5-.2-.8-.2-.6,0-.8.2c-.3,0-.5.3-.7.5s-.3.4-.4.7c0,.3-.2.6-.2,1s0,.7.2,1c0,.3.3.5.4.7.2.2.4.4.7.5s.5.2.8.2.6,0,.8-.2c.3,0,.5-.3.7-.5s.3-.4.4-.7c0-.3.2-.7.2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.5,65.6c0,.4,0,.8-.2,1.2,0,.4-.3.7-.6.9-.3.3-.6.5-.9.6-.4,0-.8.2-1.2.2s-.8,0-1.2-.2c-.4,0-.7-.3-.9-.6-.3-.3-.4-.6-.6-.9,0-.4,0-.8,0-1.2s0-.8.2-1.2c0-.4.3-.7.6-.9.3-.3.6-.5.9-.6.4,0,.8-.2,1.2-.2s.8,0,1.2.2c.4,0,.7.3.9.6.3.3.4.6.6.9,0,.3,0,.7,0,1.2ZM188.8,65.6c0-.4,0-.7-.2-1s-.3-.5-.4-.7-.4-.4-.7-.5-.5-.2-.8-.2-.6,0-.8.2c-.3,0-.5.3-.7.5s-.3.4-.4.7c0,.3-.2.6-.2,1s0,.7.2,1,.3.5.4.7c.2.2.4.4.7.5s.5.2.8.2.6,0,.8-.2c.3,0,.5-.3.7-.5s.3-.4.4-.7c0-.3.2-.7.2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,64.3c0,.4,0,.8-.4,1.1-.3.3-.7.4-1.2.5l1.5,2.4h-.9l-1.5-2.3h-1.7v2.4h-.8v-5.6h3.7c.3,0,.5.2.7.3s.3.3.5.5v.6h0ZM195.5,64.4c0-.3,0-.6-.4-.8-.2-.2-.6-.3-1.1-.3h-1.9v2.1h1.9c.5,0,.9,0,1.1-.3.3,0,.4-.4.4-.7Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.3,59.9l-.6-1.7h-3.6l-.6,1.7h-2.6l3.5-10.1h3l3.5,10.1s-2.6,0-2.6,0ZM128.7,56.3h2.4l-1.2-3.6-1.2,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.6,55.9v3.9h-2.4v-10h4c1.2,0,2.1.3,2.7.9.6.6,1,1.3,1,2.2s-.2,1.1-.5,1.7c-.4.6-.9,1-1.7,1.2l2.5,4.1h-2.9l-2.3-3.9h-.4ZM138.6,51.7v2.4h1.5c.4,0,.7,0,.9-.3.2-.2.3-.5.3-.9s-.1-.6-.3-.9c-.2-.2-.5-.3-.9-.3h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.1,59.9l-.6-1.7h-3.6l-.6,1.7h-2.5l3.5-10.1h3l3.5,10.1s-2.7,0-2.7,0ZM148.5,56.3h2.4l-1.2-3.6-1.2,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.5,59.9l-3.6-10.1h2.6l2.5,7.7,2.5-7.7h2.6l-3.6,10.1s-3,0-3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.7,59.9l-.6-1.7h-3.6l-.6,1.7h-2.6l3.5-10.1h3l3.5,10.1s-2.6,0-2.6,0ZM169.2,56.3h2.4l-1.2-3.6-1.2,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.5,49.8h2.4v8.2h3.1v1.9h-5.5s0-10.1,0-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.4,49.8h2.4v8.2h3.1v1.9h-5.5v-10.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,49.8v1.8h-3.6v2.2h3.2v1.9h-3.2v2.3h3.6v1.9h-6.1v-10.1s6.1,0,6.1,0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.1,46h-7.7c-.3,0-.5-.4-.2-.6l5.7-4.9h.5l2.1,4.9c0,.2-.2.5-.4.5h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.4,30.4c.8,0,1.4-.6,1.4-1.4s-.6-1.4-1.4-1.4-1.4.6-1.4,1.4.6,1.4,1.4,1.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 172.9,
    cy: 30.3,
    r: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 168.4,
    cy: 31.6,
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 163.9,
    cy: 32.9,
    r: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.7,38.5c-.4,0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.7,35.5c.8,0,1.4-.6,1.4-1.4s-.6-1.4-1.4-1.4-1.4.6-1.4,1.4.7,1.4,1.4,1.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.2,34.5c.9,0,1.6-.7,1.6-1.6s-.7-1.6-1.6-1.6-1.6.7-1.6,1.6.8,1.6,1.6,1.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.4,35.5c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2,1.2.5,1.2,1.2,1.2,1.2-.6,1.2-1.2Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 169.7,
    cy: 36.7,
    r: 1.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.2,37.1c-.5,0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162,43.6c-.4,0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.1,37.9c-.8,0-1.4.6-1.4,1.4s.6,1.4,1.4,1.4,1.4-.6,1.4-1.4c0-.8-.7-1.4-1.4-1.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M186.1,38.1c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6,1.6.7,1.6,1.6,1.6,1.6-.8,1.6-1.6Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 175.6,
    cy: 40.6,
    r: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 171,
    cy: 41.8,
    r: 1.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 166.5,
    cy: 43.1,
    r: 0.9
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.4,43c-.8,0-1.4.6-1.4,1.4s.6,1.4,1.4,1.4,1.4-.6,1.4-1.4-.7-1.4-1.4-1.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.9,41.6c-.9,0-1.6.7-1.6,1.6s.7,1.6,1.6,1.6,1.6-.7,1.6-1.6-.7-1.6-1.6-1.6Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.9,44.5c-.7,0-1.2.5-1.2,1.2s.5,1.2,1.2,1.2,1.2-.5,1.2-1.2-.5-1.2-1.2-1.2Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.4,33.1c-1-2.8-2-4.6-2.3-5-.4.4-.8.8-1.3,1.1.4.6,1.2,2.3,2.1,4.6,1,2.8,2.1,7.1,1.8,12.1v.2h1.7c.2-5.4-1-10.1-2-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.7,17s-2.7-.7-6.5-.5c-2.2.1-4.5.5-6.6,1.1-2.6.8-5.1,2-7.4,3.7-3.6,2.6-5.9,5.1-8.4,7.9-3,3.3-6.1,6.8-12,10.4l-10.4,6.4h3l8.2-5c6.1-3.8,9.3-7.3,12.4-10.8,2.4-2.7,4.6-5.2,8.1-7.6,2.1-1.5,4.5-2.7,6.9-3.4,2-.6,4-1,6.1-1.1,2.8-.1,4.9.2,5.7.4.3-.6.6-1,.9-1.5h0Z"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.8,
    cy: 22,
    r: 4.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 47.4,
    cy: 27.1,
    r: 14
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.6,82.4c0-16.5,13.4-29.9,29.9-29.9s29.9,13.4,29.9,29.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a3c998ec0a1096adeb498151818295f5.svg";
export { ForwardRef as ReactComponent };